import type { EnvConfig } from 'config';
import production from './production';

const cfPreview: EnvConfig = {
  ...production,
  robots: 'noindex,nofollow',
  signInUrl: '/preview-sign-in',
  skipTrackingScripts: true,
};

export default cfPreview;
